import React, { useState } from "react"
import { FaStar } from "react-icons/fa" 

var publicRating

const StarRating = (props) => {
    const [rating, setRating] = useState(null)

    const click = (ratingValue) => {
        setRating(ratingValue);
        props.handleCallBack(ratingValue);
    }

    return (
    <div>
    {[...Array(5)].map( (star, i) =>
     {
        const ratingValue = i + 1
        const iconColor = ratingValue <= rating ? "yellow" : "grey"

        return (
        <label>
            <FaStar 
            style={{display: 'inline-block', "margin-top":"-10px"}} 
            color={iconColor} 
            size={20}
            onClick={() => (click(ratingValue))}/>
        </label>
        )})}
    </div>)
}



export default StarRating